import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { buildError, prepareHeaders, API } from '../../api/apis';

/**
 * CloudManager Service
 *
 * This service provides API endpoints for CloudManager operations.
 * Similar to policies-service, it uses RTK Query for efficient data fetching and caching.
 */
export const cloudmanagerService = createApi({
    reducerPath: 'cloudmanagerApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['CloudManager'],
    endpoints: (builder) => ({
        getCloudmanager: builder.query({
            query: ({ headers }: { headers?: HeadersInit }) => ({
                url: API.FETCH_CLOUDMANAGER(),
                method: 'GET',
                headers: {
                    ...headers,
                },
            }),
            transformResponse: (response: any) => {
                return response?.Response?.CloudManager || response?.Response || [];
            },
            transformErrorResponse: (response) => {
                return buildError(response, "");
            },
            providesTags: ['CloudManager'],
        }),
    }),
});

export const {
    useGetCloudmanagerQuery,
    useLazyGetCloudmanagerQuery
} = cloudmanagerService;
